import { useState, useEffect, RefObject } from 'react';

/**
 * Hook personalizado para gestionar el estado de apertura/cierre del dropdown
 * y el comportamiento de clic fuera del dropdown.
 * 
 * @param triggerRef - Referencia al elemento que dispara el dropdown
 * @param dropdownRef - Referencia al contenedor del dropdown
 * @returns Estado de apertura y función para actualizarlo
 */
export const useMasterDropdownOpen = (
  triggerRef: RefObject<HTMLDivElement>,
  dropdownRef: RefObject<HTMLDivElement>
) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event: MouseEvent) => {
      const triggerEl = triggerRef.current;
      const dropdownEl = dropdownRef.current;
      
      if (
        triggerEl &&
        !triggerEl.contains(event.target as Node) &&
        dropdownEl &&
        !dropdownEl.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, triggerRef, dropdownRef]);

  return { open, setOpen };
};
